<template>
    <div>
        <Navigation :alwaysTop="true" />

        <BigWithSearchAndButton
            :imageName="$t('UI.banners.smallerBannerImage')"
            :title="($te('homePage.title') ? $t('homePage.title') : '')"
            :description="$te('homePage.description') ? $t('homePage.description') : ''"
        />

        <section class="mm-section mm-section__banner-list">
            <div class="box box--space-vertical"></div>
            <!--
            <div v-if="homepageData && homepageData.searchSection"
                class="mm-subsection mm-subsection--big mm-subsection--top"
                style="background-image: url('/css/images/homepage/7.png');">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content box--flex-horizontal box--flex-left">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content--with-line">
                        <div class="mm-section__banner-list-text mm-section__banner-list-text--space-top box box--flex-vertical">
                            <div class="headline headline--second text--space-bottom-l">
                                {{homepageData.searchSection.title}}
                            </div>
                            <div class="text--bigger-paragraph text--space-bottom-l">
                                {{homepageData.searchSection.description}}
                            </div>
                        </div>
                        <div class="searchbox__box-around searchbox__box-around--bigger box--white box--space-inside-s">
                            <div class="searchbox__box-around-header box--space-bottom-xs">
                                <span class="searchbox__box-around-dots">• • •</span>
                                <span>{{homepageData.searchSection.portalLink}}</span>
                            </div>
                            <div class="searchbox__box-around-bg-image"
                                style="background-image: url('/css/images/homepage/map-bg.jpg')">
                                <SearchBox
                                    formClass='searchbox__wrapper'
                                    inputClass='searchbox-input--mm'
                                    iconClass='searchbox-icon--mm'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            -->
        </section>

        <section
            v-for="(item, index) in bannerListslots"
            :key="item.id"
            class="mm-section mm-section__banner-list">

            <div class="mm-subsection mm-subsection--right d-none d-lg-flex">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content box--flex-horizontal box--flex-left">
                    <div v-if="index === 0"
                        style="margin-top: 2rem"
                        class="mm-section__banner-list-content mm-section__banner-list-content--with-line">
                        <div class="mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i :class="item.icon"></i></div>
                        </div>
                    </div>
                    <div v-else
                        class="mm-section__banner-list-content mm-section__banner-list-content--with-line">
                        <div class="mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i :class="item.icon"></i></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mm-subsection mm-subsection--big"
                :class="{
                    'mm-subsection--right' : index%2 === 0
                }"
                :style="{
                    backgroundImage: item.imageType === 'bg' ? `url(${item.imageAttachment})` : '',
                    backgroundRepeat: 'no-repeat'
                }">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content  box--flex-horizontal"
                    :class="{
                        'box--flex-right': index%2 !== 0,
                        'box--flex-left': index%2 === 0
                    }">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content-spacing  mm-section__banner-list-content--with-line"
                        :class="{
                            'box--flex-right': index%2 !== 0,
                            'box--flex-left': index%2 === 0
                        }">
                        <div class="mm-section__banner-list-text box box--flex-vertical"
                            :class="{
                                'box--left': index%2 === 0
                            }">
                            <div class="headline headline--second text--space-bottom-l">
                                {{item.title}}
                            </div>
                            <div class="text--bigger-paragraph text--space-bottom-l">
                                {{item.description}}
                            </div>
                            <router-link
                                class="mm-link"
                                :to="localeRoute(item.routeName)">
                                {{item.linkTitle}} <i class="icon icon-arrow-right"></i>
                            </router-link>
                        </div>

                        <div v-if="item.imageType === 'img'"
                            class="mm-subsection__image"
                            :style="{
                                backgroundImage: `url(${item.imageAttachment})`,
                                backgroundRepeat: 'no-repeat'
                            }">
                        </div>
                        <div v-if="item.circle === 'top'"
                            class="d-lg-none mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i :class="item.icon"></i></div>
                        </div>
                        <!--
                        <div v-if="item.circle === 'bottom'"
                            class="mm-subsection__circle">
                            <div class="mm-subsection__circle-icon"><i class="icon icon-search"></i></div>
                        </div>
                        <div v-if="item.circle === 'middle'"
                            class="mm-subsection__circle mm-subsection__circle--middle">
                            <div class="mm-subsection__circle-icon"><i class="icon icon-search"></i></div>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </section>

        <section class="mm-section mm-section__banner-list d-none d-lg-flex">
            <div class="mm-subsection mm-subsection--right">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content box--flex-horizontal box--flex-left"
                    style="min-height: 6rem;">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content--with-line">
                    </div>
                </div>
            </div>
        </section>

        <div v-if="homepageData && homepageData.favouriteCarouselSection"
            class="mm-section mm-section__banner-list">
            <div class="mm-subsection mm-subsection--right ">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content box--flex-horizontal box--flex-left">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content-spacing-s mm-section__banner-list-content--with-line">
                        <div class="mm-section__banner-list-text  box box--flex-vertical">
                            <div class="headline headline--second text--space-bottom-l">
                              {{homepageData.favouriteCarouselSection.title}}
                            </div>
                            <div class="text--bigger-paragraph text--space-bottom-l">
                              {{homepageData.favouriteCarouselSection.description}}
                            </div>
                        </div>
                        <div class="mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i class="mm-hp-icon-layers"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="homepageData && homepageData.favouriteCarouselSection"
            class="mm-section"
            style="background: #F3F3F3">
            <div class="mm-section-content" style="min-height: 0;">
                <div class="container-fluid w-100">
                    <div class="row">
                        <div class="col-12">
                            <CollapseMenu
                                :active="activeTheme"
                                :onClick="loadData"
                                :items="homepageData.favouriteCarouselSection.themes"
                                :buttonText="homepageData.favouriteCarouselSection.menuLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="homepageData && homepageData.favouriteCarouselSection"
            class="mm-section mm-section__banner-list"
            style="background-image: url(/css/images/homepage/hp/Oblubene_image.jpg); overflow: hidden;">
            <div class="mm-section-content">

                <div class="mm-section__banner-list-content mm-section__banner-list-content--with-line"
                    style="min-height: auto; padding-bottom: 2rem;">

                    <div class="container-fluid w-100">
                        <div class="row">
                            <div class="col-12 box box--space-vertical box--center">
                                <Carousel
                                    v-if="items && themesRequestState === 'SUCCESS'"
                                    :items="items"
                                    :onItemClick="onSliderItemClick"
                                />
                                <app-spinner v-else />
                                <p>
                                    <router-link :to="localeRoute(homepageData.favouriteCarouselSection.routeName)"
                                        class="mt-4 button button button--wider-border button--small-text transparent--button button--xl button--uppercase button--float-left">
                                        {{homepageData.favouriteCarouselSection.linkTitle}}
                                    </router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="homepageData && homepageData.pricingSection"
            class="mm-section mm-section__banner-list">
            <div class="mm-subsection mm-subsection--big mm-subsection--right">
                <div class="mm-subsection__mask"></div>
                <div class="mm-section-content">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content-spacing-s mm-section__banner-list-content--with-line">
                        <div class="box container-fluid w-100 box--space-top-xl">
                            <div class="row headline headline--second  box--center text--space-bottom-l">
                                {{homepageData.pricingSection.title}}
                            </div>

                            <div v-if="pricingRequestState !== 'SUCCESS'">
                                <div class="container-fluid w-100">
                                    <div class="row">
                                        <div class="col-12 box box--space-vertical box--center">
                                            <app-spinner />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="pricingPackages" class="row box--space-top">
                                <div v-for="item in pricingPackages.data.packages"
                                    :key="item.id"
                                    class="col-lg-3 col-md-4 col-sm-6 box--space-bottom">
                                    <div class="box box--bordered box--bordered--strong box--rounded-4 h-100">
                                        <div class="box--complementary box box--rounded-4" style="height: 1rem"></div>

                                        <div class="box--space-inside h-100 box--center d-flex justify-content-between flex-column">
                                            <div class="">
                                                <span class="headline headline--uppercase headline--fifth mt-4">
                                                    {{item.title}}
                                                </span>
                                                <p class="text--grey text--smaller-paragraph text--bold-paragraph">
                                                    {{item.previewText}}
                                                </p>
                                            </div>

                                            <div class="mb-4">
                                                <p>
                                                    <strong style="font-size: 3rem">{{item.price}} </strong>
                                                    <strong style="font-size: 2rem;">{{item.priceUnit}} / {{item.priceTimeUnit}}</strong>
                                                </p>
                                                <p>
                                                    <button
                                                        v-if="item.operationType === 'buy'"
                                                        @click="() => addItemToBasket(item)"
                                                        class="button button button--wider-border button--small-text transparent--button button--uppercase button--float-left">
                                                        {{homepageData.pricingSection.buyButton}}
                                                    </button>
                                                    <button v-else class="button primary--button">
                                                        {{homepageData.pricingSection.registerButton}}
                                                    </button>
                                                </p>
                                                <router-link :to="localeRoute('pricing')" class="text-link">
                                                    {{homepageData.pricingSection.linkTitle}}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mm-subsection__circle mm-subsection__circle--top box--space-top-xl">
                        <div class="mm-subsection__circle-icon"><i class="mm-hp-icon-wallet"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="homepageData && homepageData.statisticsSection && statistics"
            class="mm-section mm-section__banner-list"
            style="background-image: url(/css/images/homepage/hp/Mapsfy_image.jpg); background-repeat: no-repeat; background-position: bottom;">
            <div class="mm-subsection mm-subsection--right d-none d-lg-flex">
                <div class="mm-section-content box--flex-horizontal box--flex-left">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content--with-line">
                        <div class="mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i class="mm-hp-icon-map"></i></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mm-subsection mm-subsection--big mm-subsection--right">
                <div class="mm-section-content">
                    <div class="mm-section__banner-list-content mm-section__banner-list-content-spacing-s mm-section__banner-list-content--with-line">
                        <div class="box container-fluid w-100">
                            <div class="row">
                                <div
                                    class="col-md-3 col-sm-6 box box--space-vertical statistic-section"
                                    :key="item.id"
                                    v-for="item in mergedStatistics">
                                    <div class="headline headline--second headline--colored headline--bold statistic-heading"
                                        style="">
                                        {{item.value}}
                                    </div>
                                    <div class="statistic-subheading">
                                        <strong style="margin-bottom: 0rem; max-width: 100px" class="headline headline--sixth">
                                            {{item.name}}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-lg-none mm-subsection__circle mm-subsection__circle--top">
                            <div class="mm-subsection__circle-icon"><i class="mm-hp-icon-map"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="homepageData && homepageData.newsSection"
            class="mm-section mm-section__tiles">
            <div class="mm-section-content">
                <div class="mm-section__tiles-container">
                    <div class="mm-section__tiles-info">
                        <span class="headline headline--second headline headline--white text--space-bottom-l">
                            {{homepageData.newsSection.title}}
                        </span>
                        <p class="text--basic-paragraph text--white">
                            {{homepageData.newsSection.description}}
                        </p>
                        <router-link class="mm-link mm-link--white"
                            :to="localeRoute(homepageData.newsSection.routeName)">
                            {{homepageData.newsSection.linkTitle}} <i class="icon icon-arrow-right"></i>
                        </router-link>
                    </div>
                    <div class="mm-section__tiles-tiles">
                        <div
                            class="mm-section__tiles-tile"
                            :style="{
                                backgroundImage: `linear-gradient(rgba(3, 46, 54, 0.64), rgba(3, 46, 54, 0.58)),url(${item.imagePreview})`
                            }"
                            :key="item.id"
                            v-for="item in homepageData.newsSection.slots">
                            <div class="mm-section__tiles-tile-name text--space-bottom-l">
                                <i class="icon" :class="item.icon"></i> {{item.name}}
                            </div>

                            <router-link
                                :to="localeRoute(item.routeName)"
                                class="transparent-white--button button button--small-text default--button button--l button--icon-right button--icon-no-circle">
                                    {{item.linkTitle}}<i class="button__icon icon-arrow-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-footer />
    </div>
</template>

<script>
import Navigation from '@/components/ui/Navigation/Navigation';
import Carousel from '@/components/ui/Carousel/Carousel';
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import { getThemesPromise, getImageThemeUrl, openMapComposition, getStatistics, addItemToBasket } from '../services/MapsfyApi';
import webCMS from '@/services/WebCMS';
import CollapseMenu from '@/components/ui/CollapseMenu';
import BigWithSearchAndButton from '@/components/ui/Banner/BigWithSearchAndButton';

export default {
    name: 'home',
    components: {
      Navigation,
      Carousel,
      BigWithSearchAndButton,
      CollapseMenu
    },
    data() {
        return {
            items:  null,
            statistics: null,
            publicPath: process.env.BASE_URL,
            pricingRequestState: null,
            pricingPackages: null,
            activeTheme: null,
            homepageData: this.$te('homePage') ? this.$t('homePage') : null,
            bannerListslots: this.$te('homePage.bannerListslots') ? this.$t('homePage.bannerListslots') : null
        }
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        if (this.homepageData) {
            this.loadData(this.homepageData.favouriteCarouselSection.themes[0]);
        }
        this.loadPricing();
        this.getStatistics();
    },
    computed: {
        mergedStatistics() {
            let statistics = [];

            if (this.statistics && this.homepageData.statisticsSection && this.homepageData.statisticsSection.slots) {
                statistics = this.homepageData.statisticsSection.slots.filter(item => {
                        return (item.atrName && this.statistics[item.atrName]);
                    })
                    .map(item => {
                        item.value = this.statistics[item.atrName];
                        return item;
                    });
            }

            return statistics;
        }
    },
    methods: {
        onSliderItemClick(item) {
            this.$router.push({name: 'mapApp'});
            openMapComposition(item.id);
        },
        addItemToBasket(product) {
            this.$router.push({name: 'mapApp'});
            addItemToBasket(product.id);
        },
        getStatistics() {
            this.statisticsRequestState = null;
            this.statisticsRequestState = 'REQUEST';
            getStatistics()
                .then(res => {
                    if (res && res[0]) {
                        this.statisticsRequestState = "SUCCESS";
                        this.statistics = res[0];
                    } else {
                        this.statisticsRequestState = "FAILURE";
                    }
                })
                .fail(() => {
                    this.statisticsRequestState = "FAILURE";
                });
        },
        loadPricing() {
            this.pricingRequestState = "REQUEST";

            webCMS.getPricingPackages(this.axios)
                .then(res => {
                    this.pricingPackages = res;
                    this.pricingRequestState = "SUCCESS";
                })
                .catch(() => {
                    this.pricingRequestState = "FAILURE";
                });
        },
        loadData(theme) {
            const bbox = theme.geom;
            this.themesRequestState = "REQUEST";
            this.items = null;
            this.activeTheme = theme;

            // eslint-disable-next-line
            getThemesPromise('popular', bbox)
                .then(res => {
                    this.themesRequestState = "SUCCESS";
                    this.items = res.map(item => {
                        return {
                            id: item.hash,
                            text: item.name,
                            imageUrl: getImageThemeUrl(item)
                        };
                    });
                })
                .fail(() => {
                    this.themesRequestState = "FAILURE";
                });
        }
    }
}
</script>


<style lang="scss" scoped>

@media (min-width: 768px) {
    .vue-page .mm-subsection--big .mm-section-content {
        min-height: 11rem;
    }

    .vue-page .mm-section-content {
        min-height: 11rem;
    }
}

@media (max-width: 576px) {
    .statistic-section {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
    }

    .statistic-heading {
        margin-bottom: 0px !important;
        padding-right: 2rem;
        flex-grow: 1;
        flex-basis: 0;
        width: 50%;
        text-align: right;
    }

    .statistic-subheading {
        width: 50%;
        padding-right: 2rem;
        margin-bottom: 0rem;
        flex-grow: 1;
        flex-basis: 0;
        text-align: left;
    }
}

@media (max-width: 991px) {
    .vue-page .mm-subsection__circle {
        top: -2rem;
    }
}
</style>